import React from 'react';
import AsyncListTutorials from './listtutorials/async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';

const parent = {
  title: <Trans i18nKey="p.s.t.tutorials.title">Tutorials</Trans>,
  path: '/support/tutorials',
};
export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/support/tutorials/list-tutorials"
    component={AsyncListTutorials}
    title={<Trans i18nKey="p.s.t.listtutorials.title">List Tutorials</Trans>}
    parents={[parent]}
  />,
  <Redirect
    key="b"
    exact
    from="/support/tutorials"
    to="/support/tutorials/list-tutorials"
  />,
];
